import axios from 'axios';

const instance = axios.create({
  baseURL: "https://apinekros-valcantara.sig-norba.com",
  withCredentials: true,
});

export default instance;